import { useDisclosure } from '@chakra-ui/react'
import { createContext, useState } from 'react'

import EditSessionDetails from '../components/EditSessionDetails'

const SideDrawerContext = createContext()

const SideDrawerProvider = ({ children }) => {
    const {
        isOpen: isDrawerOpen,
        onOpen: onDrawerOpen,
        onClose: onDrawerClose,
    } = useDisclosure()

    const [drawerData, setDrawerData] = useState({})

    const handleDrawerOpen = data => {
        setDrawerData(data)
        onDrawerOpen()
    }

    return (
        <SideDrawerContext.Provider
            value={{
                isDrawerOpen,
                onDrawerOpen: handleDrawerOpen,
                onDrawerClose,
            }}
        >
            {children}
            <EditSessionDetails
                isOpen={isDrawerOpen}
                onClose={onDrawerClose}
                {...drawerData}
            />
        </SideDrawerContext.Provider>
    )
}

export default SideDrawerContext
export { SideDrawerProvider }
